import Image from "next/image";

const SingleService = props => {
    let services = props.data.map((item, index) => {
        return (
            <div
                key={index}
                className="flex flex-col pt-12 md:pt-28"
                id={item.title.toLowerCase().split(" ").join("-")}
            >
                <div className="flex flex-col md:flex-row">
                    <div className="md:w-32 text-center md:text-left">
                        <Image
                            alt="post feature image."
                            src={item.feature_image}
                            width="128"
                            height="128"
                            layout="intrinsic"
                            loading="lazy"
                        />
                    </div>
                    <div className="post-content pt-9 md:pt-0 md:pl-12">
                        <div className="flex-auto font-body font-extrabold text-4xl">
                            {item.title}
                        </div>
                        <div className="bg-blue-500 h-1 w-20 my-6"></div>
                        <div className="font-body mb-12 text-xl font-light text-gray-600 italic">
                            {item.excerpt}
                        </div>
                    </div>
                </div>
                <div
                    className="font-body text-xl font-normal text-gray-600"
                    id="serviceSection"
                    dangerouslySetInnerHTML={{
                        __html: item.html,
                    }}
                ></div>
            </div>
        );
    });

    return (
        <div className="flex flex-col mx-5 md:mx-16 pb-12 md:pb-20">{services}</div>
    );
};

export default SingleService;
